﻿import { onlyDigits } from "@js/core/utils/text";
import { detectCardType, formatExpireDate } from "@js/core/forms/card";

function applyCardNumberMask($input) {
    const digits = onlyDigits($input.val());
    const cardType = detectCardType(digits);

    const maskPattern = cardType === "amex"
        ? "9999 999999 99999"
        : "9999 9999 9999 9999";

    const currentMask = $input.data("current-mask");
    if (currentMask === maskPattern) return;

    $input.data("current-mask", maskPattern);

    $input.inputmask("remove");
    $input.inputmask({
        mask: maskPattern,
        placeholder: " ",
        showMaskOnHover: false,
        showMaskOnFocus: true,
        clearIncomplete: false,
        jitMasking: true
    });

    $input.val(digits);
}

export function updateCvvMask() {
    if (!window.jQuery?.fn?.inputmask) return;

    const $ = window.jQuery;
    const $cvv = $("#Cvv");
    const cardNumber = $("#CardNumber").val() || "";
    const type = detectCardType(cardNumber);

    if (!$cvv.length) return;

    const currentMask = $cvv.data("current-mask");
    const nextMask = type === "amex" ? "9999" : "999";

    if (currentMask === nextMask) return;

    $cvv.data("current-mask", nextMask);
    $cvv.inputmask("remove");

    $cvv.inputmask({
        mask: nextMask,
        placeholder: "",
        showMaskOnHover: false,
        showMaskOnFocus: true,
        clearIncomplete: false,
        jitMasking: true
    });
}

export function initCheckoutMasks() {
    if (!window.jQuery?.fn?.inputmask) return;

    const $ = window.jQuery;

    const $card = $(".js-card-number");
    if ($card.length) {
        applyCardNumberMask($card);

        $card.on("input keyup paste blur", function () {
            const $this = $(this);
            let digits = onlyDigits($this.val());

            const maxLength = detectCardType(digits) === "amex" ? 15 : 16;
            if (digits.length > maxLength) {
                digits = digits.substring(0, maxLength);
                $this.val(digits);
            }

            applyCardNumberMask($this);
            updateCvvMask();
        });
    }

    const $expire = $(".js-expire-date");
    if ($expire.length) {
        $expire.on("input", function () {
            let digits = onlyDigits(this.value).substring(0, 4);

            if (digits.length === 1) {
                const first = parseInt(digits, 10);
                if (first >= 2 && first <= 9) {
                    digits = "0" + digits;
                }
            }

            if (digits.length >= 2) {
                const month = parseInt(digits.substring(0, 2), 10);

                if (month <= 0) {
                    digits = "01" + digits.substring(2);
                } else if (month > 12) {
                    digits = "12" + digits.substring(2);
                }
            }

            this.value = formatExpireDate(digits);
        });

        $expire.on("blur", function () {
            this.value = formatExpireDate(this.value);
        });
    }

    const $cvv = $(".js-cvv");
    if ($cvv.length) {
        $cvv.inputmask({
            mask: "9999",
            placeholder: "",
            showMaskOnHover: false,
            showMaskOnFocus: true,
            clearIncomplete: false,
            greedy: false
        });
        updateCvvMask();
    }

    const $amount = $(".js-amount");
    if ($amount.length) {
        $amount.inputmask("decimal", {
            groupSeparator: ".",
            radixPoint: ",",
            digits: 2,
            autoGroup: true,
            rightAlign: false,
            allowMinus: false,
            prefix: "",
            placeholder: "0"
        });

        $amount.on("blur", function () {
            const val = $(this).val();
            const normalized = val.replace(/\./g, "").replace(",", ".");
            const number = parseFloat(normalized);

            if (!Number.isNaN(number) && number <= 0) {
                $(this).addClass("is-invalid");
            } else {
                $(this).removeClass("is-invalid");
            }
        });
    }

    const cardHolder = document.getElementById("CardHolder");
    if (cardHolder) {
        cardHolder.addEventListener("input", function () {
            this.value = this.value
                .replace(/[^a-zA-ZçÇğĞıİöÖşŞüÜ\s]/g, "")
                .replace(/\s{2,}/g, " ");
        });
    }
}